const API = "/api/v1/admin/persona-imports";

export class PersonaImportApiError extends Error {
  constructor(status, data) {
    super(data?.error || data?.message || `HTTP ${status}`);
    this.name = "PersonaImportApiError";
    this.status = status;
    this.code = data?.code;
    this.data = data;
  }
}

async function request(path, { method = "GET", body, signal } = {}) {
  const response = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: body === undefined ? undefined : { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
    signal,
  });
  const text = await response.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!response.ok) throw new PersonaImportApiError(response.status, data);
  return data;
}

export const personaImports = {
  list: ({ signal, query } = {}) => request(query ? `?${new URLSearchParams(query).toString()}` : "", { signal }),
  history: ({ signal, query } = {}) => request(`/history${query ? `?${new URLSearchParams(query).toString()}` : ""}`, { signal }),
  importExport: (exportId, { signal } = {}) =>
    request(`/${encodeURIComponent(exportId)}/import`, {
      method: "POST",
      body: { consent_confirmed: true },
      signal,
    }),
  reconcile: ({ signal } = {}) =>
    request("/reconcile", { method: "POST", signal }),
};

export default personaImports;
